module.exports = __webpack_public_path__ + "static/media/ic_facebook.82796c39.svg";